module.exports = __webpack_public_path__ + "img/86b03cc.png";